import { useDispatch } from 'react-redux';
import { changeCatalogName } from 'modules/queryBuilder/legacyQueryBuilder/actions';

export const useCatalogFieldFacets = () => {
  const dispatch = useDispatch();

  return (catalogName = '') => dispatch(changeCatalogName(catalogName));
};
